import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Progress, Text} from '@gravity-ui/uikit';

import {AnswerStatProps} from './AnswerStat.types';

import './AnswerStat.scss';

const cnAnswerStat = cn('AnswerStat');

const AnswerStat: FC<AnswerStatProps> = ({label, percent}) => {
    return (
        <div className={cnAnswerStat()}>
            <div className={cnAnswerStat('Header')}>
                <Text variant="body-2" className={cnAnswerStat('Answer')}>
                    {label}
                </Text>
                <Text variant="body-2" className={cnAnswerStat('Percent')}>{`${percent.toFixed(
                    1,
                )}%`}</Text>
            </div>
            <Progress size="xs" value={percent} theme="info" className={cnAnswerStat('Progress')} />
        </div>
    );
};
export default AnswerStat;
